<template>
  <div id="container">
    <div class="item-box-content" v-show="$route.query.type !== 'red'">
      <div class="title-font-style">
        <span>退票信息</span>
      </div>
      <el-form style="padding:20px 20px 0 20px;">
        <el-form-item label="退票原因：" style="margin-bottom: 0;" label-width="88px">
          <el-input type="textarea" :rows="4" v-model="dataList.mark"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="item-box-content">
      <div class="title-font-style">
        <span>发票清单</span>
      </div>
      <el-table
        style="margin-top:20px;"
        border
        ref="tableRef"
        :data="list"
        @current-change="handleCurrentChange"
        tooltip-effect="dark"
        highlight-current-row
        :header-cell-style="tableHeader"
        v-loading="loadingTable"
        element-loading-text="拼命加载中请稍后..."
        height="378"
        element-loading-spinner="el-icon-loading"
      >
        <el-table-column type="index" width="50"></el-table-column>
        <el-table-column prop="invoiceNumber" label="发票编号"></el-table-column>
        <el-table-column show-overflow-tooltip prop="suName" label="公司名称"></el-table-column>
        <el-table-column prop="amount" label="发票金额"></el-table-column>
        <el-table-column prop="createDate" label="申请时间">
          <template slot-scope="scope">
            <span>{{ scope.row.createDate | dateFilter }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="invoiceType" label="发票类型"></el-table-column>
        <el-table-column prop="invoiceReceiveDate" label="收票时间">
          <template slot-scope="scope">
            <span>{{ scope.row.invoiceReceiveDate | dateFilter }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="processUser" label="处理人"></el-table-column>
      </el-table>
    </div>
    <div class="item-box-content" v-show="$route.query.type !== 'red'">
      <div class="title-font-style">
        <span>收票信息</span>
      </div>
      <el-form style="padding:20px 30px 0 30px" label-width="70px">
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="收票人：">
              <el-input v-model="dataList.receivePeople"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="联系电话：">
              <el-input @input.native="onInput" v-model="dataList.receivePhone"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="收票地址：">
              <el-address @changAddress="changAddress"></el-address>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="详细地址：">
              <el-input v-model="dataList.receiveAddress"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <el-row style="margin-top:20px;" v-show="$route.query.type === 'red'">
      <el-col :span="24">
        <el-button @click="onNextStep" type="primary">下一步</el-button>
      </el-col>
      <el-col :span="24" style="margin-top:16px;">单次仅允许对一张发票申请红字信息表</el-col>
    </el-row>
    <el-row style="margin-top:20px;" v-show="$route.query.type !== 'red'">
      <el-col :span="24">
        <el-button @click="onApplyForRefund" type="primary">申请退票</el-button>
      </el-col>
      <el-col :span="24" style="margin-top:16px;">单次仅允许申请一张发票退回，请申请后尽快将未核销票据交至财务部</el-col>
    </el-row>
    <!-------------- 申请退款二次确认 -------------->
    <open-or-close
      ref="OpenOrCloseRefs"
      @onUpdataState="onUpdataState"
      :title="title"
      :content="content"
    ></open-or-close>
  </div>
</template>
<script>
import {
  queryInvoiceSub,
  addPurchaseInvoiceSub
} from '@/api/purchase/purchasePlanList'
import address from '@/components/Address/index'
import { formatDate } from '@/util/tool'

import openOrClose from '@/components/OpenOrClose/index'
export default {
  components: {
    'el-address': address,
    'open-or-close': openOrClose
  },
  data () {
    return {
      result: '',
      list: [],
      dataList: {
        mark: undefined,
        receiveAddress: undefined,
        receivePeople: undefined,
        receivePhone: undefined,
        receiveProcode: undefined,
        receiveProvince: undefined
      }, // 传给后台的数据
      loadingTable: false,
      title: '',
      content: '',
      returnTicket: '' // 退票清单
    }
  },
  mounted () {
    queryInvoiceSub(this.$route.query.pcbId, this.$route.query.typeex)
      .then(res => {
        if (res.data.code === 200) {
          this.list = res.data.obj
        }
      })
      .catch(err => {
        console.log(err)
      })
  },
  methods: {
    onInput(e) {
      // 过滤非数字和符号-
      const regName = /^[\d-]+$/
      if (!regName.test(e.target.value)) {
        e.target.value = ''
      } else {
        return true
      }
    },
    changAddress (val) {
      this.dataList.receiveProcode = val.code
      this.dataList.receiveProvince = val.name
    },
    //   选中数据
    handleCurrentChange (val) {
      this.returnTicket = val
    },
    // 设置头部背景色
    tableHeader ({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    },
    // 下一步
    onNextStep () {
      if (this.returnTicket === '') {
        this.$message.error('请选择需要退票的发票！')
      } else {
        this.$router.push({
          name: 'redApplyForTicketCollection',
          query: {
            pciId: this.returnTicket.pciId,
            invoiceNumber: this.returnTicket.invoiceNumber,
            pcbId: this.$route.query.pcbId,
            sendType: this.$route.query.sendType
          }
        })
      }
    },
    // 申请退票
    onApplyForRefund () {
      const dataArray = Object.values(this.dataList)
      if (dataArray.every(item => item)) {
        if (this.returnTicket === '') {
          this.$message.error('请选择需要退票的发票！')
        } else {
          this.dataList.pciId = this.returnTicket.pciId

          this.title = '确认退票'
          this.content = '退票申请发起后不可撤回，是否确认退票？'
          this.$refs.OpenOrCloseRefs.onInitial()
        }
      } else {
        this.$message.error('请填写完整退票信息')
      }
    },
    onUpdataState () {
      addPurchaseInvoiceSub(this.dataList)
        .then(res => {
          if (res.data.code === 200) {
            this.$message.success('已申请退票，请等待审核！')
            this.$router.push({
              name: 'contractDetails',
              query: {
                type: this.$route.query.sendType,
                pcbId: this.$route.query.pcbId
              }
            })
          }
        })
        .catch(err => {
          console.log(err)
        })
    }
  },
  filters: {
    dateFilter
  }
}
function dateFilter (time) {
  if (time === null) {
    return ''
  } else {
    const date = new Date(time)
    return formatDate(date, 'yyyy-MM-dd hh:mm')
  }
}
</script>
<style lang="scss" scoped></style>
